import generateDirective from '../generator';
import VehicleStageController from './controller';

generateDirective('Vehicle', '/customer_application_renderer/stages/vehicle/form.html', VehicleStageController);
